import { ErrorBoundary as ReaectErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "./ErrorFallback";

export function ErrorBoundary(props) {
  return <ReaectErrorBoundary fallbackRender={ErrorFallback} {...props} />;
}
